import React, { useState, useEffect } from "react";
import Header from "../../../Components/Header";
import Seo from "../../../Components/SeoComponent/Seo";
import { showSuccessToast, showErrorToast } from "../../../utils/toastUtils";
import { fetchProfile } from "../../../Services/ApiTestService/aadharTestService";
import { verifyMobileValidationBasic } from "../../../Services/ApiTestService/apiTestService";
import { InputWithLabel, Button } from "../../../Components/Tags/Tags";
import Loader from "../../../Loader";
import { Data4 } from "../Data";
import { Link } from "react-router-dom";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import { useService } from "../../../context/ServiceContext";  


const MobileValidationBasic = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [mobileData, setMobileData] = useState({});
  const [errors, setErrors] = useState({});
  const [profileData, setProfileData] = useState({});
  const [mobNumber, setMobNumber] = useState("");
  const [options, setOptions] = useState([]); 
  const { serviceName } = useService();
  // Fetch profile data on mount
  useEffect(() => { 
    const fetchProfileData = async () => {
      try {
        setIsLoading(true);
        const response = await fetchProfile();
        setProfileData(response.data);
      } catch (error) {
       // console.error("Error fetching profile data:", error);
        showErrorToast("Failed to fetch profile data.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchProfileData();
  }, []);

  // Form validation
  const validateForm = (mobNumber) => {
    const errors = {};
  
    if (!mobNumber.trim()) {
      errors.mobNumber = "Mobile number is required.";
    }
      else if (!/^[1-9][0-9]{9}$/.test(mobNumber)) {
        errors.mobNumber = "Mobile number must be 10 digits and not start with 0.";
      }
      
  
    return errors;
  };
  


    // ✅ Handle Option Change
  const handleOptionChange = (e) => {
    const selectedOption = e.target.value;
    if (options.includes(selectedOption)) {
      setOptions(options.filter((opt) => opt !== selectedOption));
    } else {
      setOptions([...options, selectedOption]);
    }
  };

  // ✅ Handle Submit
  const handleSubmit = async () => {
    const validationErrors = validateForm(mobNumber);
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length > 0) return;

    try {
      setIsLoading(true);

      const response = await verifyMobileValidationBasic({
        api_id: profileData?.user_id,
        api_key: profileData?.api_key,
        token_id: profileData?.token_id,
        mobile_number: mobNumber,
        options: options.length > 0 ? options : undefined,
      });


      const statusCode = response?.status?.code;
      const statusMessage =
        response?.status?.message || response?.message;

      if (statusCode === 200) {
        const mobileDetails = response?.data;

        if (mobileDetails && typeof mobileDetails === "object") {
          setMobileData(mobileDetails);
          showSuccessToast(
            statusMessage || "Mobile number verified successfully."
          );
          setErrors({});
        } else {
          showErrorToast(
            "Mobile details are missing or in an unexpected format."
          );
        }
      } else {
        const errorMessage =
          response?.message ||
          response?.data?.message ||
          statusMessage ||
          `Something went wrong. (code: ${statusCode})`;
        showErrorToast(errorMessage);
      }
    } catch (error) {
      console.error("Verify Mobile Error:", error);
      showErrorToast("Failed to verify mobile details. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Seo />
      {isLoading && <Loader />}
      <Header heading={serviceName} />

      <div className="grid grid-cols-2 md:grid-cols-4 gap-2 justify-center md:ml-80 ml-0 p-4">
        
      <div className="col-span-2 md:col-span-6 flex justify-end">
  <Link
    to="/TestMaster"
    className="flex items-center gap-1 text-white bg-green-600 hover:bg-green-700 px-1 py-1 rounded-md font-semibold shadow-md transition duration-300"
  >
    <span>Go Back</span>
    <IoArrowBackCircleOutline size={24} />
  </Link>
</div>

        
        
        <InputWithLabel
          type="text"
          label="Mobile Number"
          placeholder="Enter Mobile No"
          maxLength="10"
          className="p-1 rounded shadow-lg shadow-blue-500/50 border border-blue-600"
          name="mobile_number"
          id="mobile_number"
          required={true}
          value={mobNumber}
          onChange={(e) => setMobNumber(e.target.value)}
          error={errors.mobNumber}
        />

          {/* ✅ Options (optional field) */}
      <div className="mt-4">
        <label className="text-sm font-medium text-gray-700">
          Additional Options:
        </label>
        <div className="flex flex-col sm:flex-row gap-2 mt-2">
          <label className="flex items-center gap-2">
            <input
              type="checkbox"
              value="customer_details"
              checked={options.includes("customer_details")}
              onChange={handleOptionChange}
              className="w-4 h-4 text-blue-600"
            />
            <span>Customer Details</span>
          </label>

          {/* Future checkboxes if API supports more options */}
          {/* <label className="flex items-center gap-2">
            <input
              type="checkbox"
              value="connection_history"
              checked={options.includes("connection_history")}
              onChange={handleOptionChange}
              className="w-4 h-4 text-blue-600"
            />
            <span>Connection History</span>
          </label> */}
        </div>
      </div>

        <div>
          <Button
            type="button"
            className="text-center text-white bg-blue-900 shadow-lg bg-gradient-to-r from-blue-400 via-blue-1200 to-blue-900 font-semibold rounded-md px-2 py-1 mt-5 text-md hover:from-blue-900 hover:to-blue-400 border-4 ms-2"
            id="verifyMob"
            name="verifyMob"
          text={isLoading ? "Verifying..." : "Verify"}
            onClick={handleSubmit}
          />
        </div>
      </div>

      {mobileData && Object.keys(mobileData).length > 0 && (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 px-4 my-4">

    {/* First Half - JSON Response */}
    <div className="bg-white border border-green-300 rounded-md shadow-lg p-2 max-w-xl mx-auto">
      <h2 className="text-lg font-semibold text-yellow-800 mb-2">Raw Response (JSON)</h2>
      <pre className="text-sm bg-gray-100 p-2 rounded-md">{JSON.stringify(mobileData, null, 2)}</pre>
    </div>

    {/* Second Half - Bank Details */}
<div className="bg-white border border-green-300 rounded-md shadow-lg p-6 max-w-xl mx-auto">
  <h2 className="text-xl font-semibold text-green-800 mb-4 border-b pb-2">
    Mobile Details
  </h2>

  {/* ✅ Basic Info */}
  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm text-gray-700">
    <p><strong>Full Name:</strong> {mobileData?.customer_details?.name || "N/A"}</p>
    <p><strong>Mobile Number:</strong> {mobileData?.msisdn?.msisdn || "N/A"}</p>
             <p><strong>Mobile Number:</strong> {mobileData?.customer_details?.alternate_number || "N/A"}</p>  
    <p><strong>Country Code:</strong> {mobileData?.msisdn?.msisdn_country_code || "N/A"}</p>
    <p><strong>Connection Type:</strong> {mobileData?.connection_type || "N/A"}</p>
    <p><strong>Subscriber Status:</strong> {mobileData?.subscriber_status || "N/A"}</p>
    <p><strong>Is Valid:</strong> {mobileData?.is_valid ? "Yes" : "No"}</p>
    <p><strong>Is Ported:</strong> {mobileData?.is_ported ? "Yes" : "No"}</p>
    <p><strong>Last Ported Date:</strong> {mobileData?.last_ported_date || "N/A"}</p>
  </div>

  {/* ✅ Current Service Provider */}
  <div className="mt-5">
    <h3 className="text-md font-semibold text-green-700 border-b pb-1 mb-2">Current Service Provider</h3>
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm text-gray-700">
      <p><strong>Network Name:</strong> {mobileData?.current_service_provider?.network_name || "N/A"}</p>
      <p><strong>Region:</strong> {mobileData?.current_service_provider?.network_region || "N/A"}</p>
      <p><strong>Prefix:</strong> {mobileData?.current_service_provider?.network_prefix || "N/A"}</p>
      <p><strong>Country:</strong> {mobileData?.current_service_provider?.country_name || "N/A"}</p>
    </div>
  </div>

  {/* ✅ Original Service Provider */}
  <div className="mt-5">
    <h3 className="text-md font-semibold text-green-700 border-b pb-1 mb-2">Original Service Provider</h3>
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm text-gray-700">
      <p><strong>Network Name:</strong> {mobileData?.original_service_provider?.network_name || "N/A"}</p>
      <p><strong>Region:</strong> {mobileData?.original_service_provider?.network_region || "N/A"}</p>
      <p><strong>Prefix:</strong> {mobileData?.original_service_provider?.network_prefix || "N/A"}</p>
      <p><strong>Country:</strong> {mobileData?.original_service_provider?.country_name || "N/A"}</p>
    </div>
  </div>

  {/* ✅ Connection Status */}
  <div className="mt-5">
    <h3 className="text-md font-semibold text-green-700 border-b pb-1 mb-2">Connection Status</h3>
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm text-gray-700">
      <p><strong>Status Code:</strong> {mobileData?.connection_status?.status_code || "N/A"}</p>
      <p><strong>Error Code:</strong> {mobileData?.connection_status?.error_code_id || "N/A"}</p>
    </div>
  </div>
</div>


  </div>
)}




    </>
  );
};

export default MobileValidationBasic;
